(function () {
    'use strict';

    angular.module('Directives').directive('bbaConnectionDetails', bbaConnectionDetails);

    bbaConnectionDetails.$inject = [
        '$rootScope',
        'Carrier',
        'toastr',
        'aborter',
        'isUniqueService',
        'ServicesService',
        '$q',
        '$timeout',
        'Location',
        'QuoteCalculationType'
    ];

    function bbaConnectionDetails(
        $rootScope,
        Carrier,
        toastr,
        aborter,
        isUniqueService,
        ServicesService,
        $q,
        $timeout,
        Location,
        QuoteCalculationType
    ) {
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/components/margins/bba-connection-details.html',
            require: ['^form', 'ngModel'],
            scope: {
                ngModel: '=',
                ngRawData: '=',
                isViewMode: '=?',
                carrierProfileOnSelect: '=?'
            },
            link: BBAConnectionDetailsLink
        }

        function BBAConnectionDetailsLink($scope, attr, element, ngModels) {
            let origName = '';
            $scope.currentUser = $rootScope.GlobalProfile;
            $scope.$watch('ngRawData', (value) => {
                if (value) origName = value.name;
            });
            $scope.form = ngModels[0];
            $scope.selectedCountry = null;
            $scope.destinationStates = null;
            $scope.quoteCaculationTypes = QuoteCalculationType.types;

            $scope.searchServiceProfile = searchServiceProfile;
            $scope.searchCarrierProfiles = searchCarrierProfiles;
            $scope.validateProfileName = validateProfileName;
            $scope.roundDown = roundDown;
            $scope.onSelectCarrierProfile = onSelectCarrierProfile;
            $scope.initDriverDirect = initDriverDirect;
            $scope.searchForStates = searchForStates;
            $scope.selectCountry = selectCountry;
            $scope.onSelectStates = onSelectStates;
            $scope.onRemoveState = onRemoveState;

            $scope.ServiceProfileOptionals = {
                'fastway-colored-label': true
            };

            init();

            function init() {
                getCountries().then((data) => {
                    $scope.countries = data;
                    setDestinationStates();
                });
            }

            function setDestinationStates() {
                const unwatch = $scope.$watch('ngModel.destinationStates', (value) => {
                    if (value) {
                        $scope.destinationStates = $scope.ngModel.destinationStates;
                        setSelectedCountry();
                        unwatch();
                    }
                });
            }

            function setSelectedCountry() {
                if ($scope.ngModel.destinationStates.length < 1) { return; }
                const state = $scope.ngModel.destinationStates[0].name;
                Location.locationEnabled({state}, data => {
                    if (data.content.length < 1) { return; }
                    $scope.selectedCountry = data.content[0].country;
                }, error => {
                    toastr.error(error.message, 'Error');
                });
            }

            function getCountries() {
                const deferred = $q.defer();
                Location.Country({}, data => {
                    deferred.resolve(data);
                }, error => {
                    deferred.reject(error);
                    toastr.error(error.message, 'Error');
                });
                return deferred.promise;
            }

            function searchServiceProfile(select, carrierProfile, filters) {
                const defer = $q.defer();
                if (!select.open) {
                    $timeout(() => defer.resolve());
                    return defer.promise;
                }
                $scope.dropdownFetching = true;
                $scope.serviceProfiles = [];

                if (!carrierProfile) { return; }
                Carrier.getCarrierProfiles(carrierProfile.id, data => {
                    $scope.serviceProfiles = data.content.sort((a, b) => a.name.localeCompare(b.name));
                    $scope.dropdownFetching = false;
                    defer.resolve(data);
                }, error => {
                    defer.reject(error);
                }, angular.extend({
                    size: 10,
                    name: select.search
                }));
                return defer.promise;
            }

            function searchCarrierProfiles(search) {
                $scope.dropdownFetching = true;
                $scope.carrierProfiles = [];
                Carrier.carrierProfilesCompact(data => {
                    $scope.carrierProfiles = data.content.sort((a, b) => a.name.localeCompare(b.name));
                    $scope.dropdownFetching = false;
                }, error => {
                    toastr.error('Unable to fetch carrier profiles', error.message);
                    $scope.dropdownFetching = false;
                }, {
                    size: 10,
                    name: search,
                    isReceived: true
                });
            }

            function validateProfileName(name) {
                let data = {
                    model: name,
                    formField: ngModels[0].profileName,
                    service: ServicesService,
                    serviceMethod: 'getClientServiceLinks',
                    property: 'name',
                    warningMsg: 'Profile name is already in used. Please choose another one.',
                    origName: origName
                };
                isUniqueService.isUnique(data);
            }

            function onSelectCarrierProfile(carrierProfile) {
                $scope.carrierProfileOnSelect();
                $scope.noServiceRequired = false;
                $scope.serviceProfile = false;
                if (angular.getObjVal(carrierProfile, 'carrier.id') === 'fastway-colored-label') {
                    $scope.serviceProfile = true;
                    toastr.info('Service profile is not required for FCL connections.', ' ');
                    searchServiceProfile({
                        open: true,
                        search: '',
                    }, carrierProfile, {size: 1}).then(data => {
                        if (!data || !data.content.length) {
                            $scope.noServiceRequired = false;
                        }
                    });
                }
            }

            function initDriverDirect(selected) {
                if (selected.id === '1') {
                    $scope.ngModel.driverDirectEnabled = true;
                }
            }

            function roundDown(model) {
                return parseFloat(model).roundDown(2);
            }

            function selectCountry(item) {
                $scope.selectedCountry = item;
                $scope.destinationStates = [];
                searchForStates();
            }

            function searchForStates(searchTerm) {
                $scope.states = [];
                if (!$scope.selectedCountry) { return; }

                aborter(() => {
                    getStates({name: searchTerm});
                }, 500);
            }

            function getStates(filter) {
                $scope.isSearching = true;
                const country = $scope.selectedCountry;
                Location.State(angular.getObjVal(country, 'id'), (data) => {
                    $scope.isSearching = false;
                    $scope.states = data.map(loc => {
                        return {
                            name: loc.name,
                            code: loc.code,
                            countryCode: country.code
                        }
                    });
                }, error => {}, {}, filter);
            }

            function onSelectStates(items) {
                $scope.ngModel.destinationStates = items;
            }

            function onRemoveState(item) {
                const items = angular.copy($scope.destinationStates);
                const filtered = items.filter(i => i.name !== item.name);;
                $scope.destinationStates = filtered;
                $scope.ngModel.destinationStates = $scope.destinationStates;

            }
        }
    }
})();



// WEBPACK FOOTER //
// ./js/directives/component/margins/bbaConnectionDetails.js